var map = {
	"./20110227_1.jpg": 44551,
	"./20110227_2.jpg": 28056,
	"./20110227_3.jpg": 72885,
	"./20110227_4.jpg": 35822,
	"./20110227_5.jpg": 15307,
	"./20110227_6.jpg": 90140,
	"./20110227_7.jpg": 34489,
	"./20110227_8.jpg": 21570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12619;